module.exports = __webpack_public_path__ + "static/media/instagram-stories-bee.e8c56bed.mp4";